import { ALL_AVAILABLE_BLOCKS } from '../../const';
import { NodeEnum, type NodeDefault } from '../../types';
import type { StartNodeType } from './types';

const nodeDefault: NodeDefault<StartNodeType> = {
  author: 'PIKA',
  about: '开始节点描述',
  icon: 'icon-video_fill_light',
  color: '#2E90FA',
  deletable: false,
  name: '开始节点',
  defaultData: {
    type: NodeEnum.Start,
    name: '开始节点',
    title: '开始节点',

  },
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes() {
    const nodes = ALL_AVAILABLE_BLOCKS;
    return nodes;
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
